import { useCallback, useMemo } from 'react'

import { useInView } from 'react-cool-inview'

import { SEARCH_EVENT_SOURCE } from 'Pods/Shared/UserTracker/UserTracker'

import { trackPromotion } from './searchPageTracker'

const PROMOTION_NAME = 'search_promo_cards'
const CREATIVE_NAME = 'promo_card'

/**
 * The collections hub promotion events (CollectionHub/Hooks/usePromoTracking) for a search promo
 * card, sent through the search page data layer so they carry its page attributes.
 */
export default function usePromoTracking({ id, slot, index }) {
  const eventData = useMemo(() => ({
    promotion_id: id,
    promotion_name: PROMOTION_NAME,
    creative_name: CREATIVE_NAME,
    creative_slot: slot,
    index,
  }), [id, slot, index])

  const { observe } = useInView({
    threshold: 0.5,
    unobserveOnEnter: true,
    onEnter: () => trackPromotion({
      eventName: 'view_promotion', eventSource: SEARCH_EVENT_SOURCE.SEARCH_PAGE, eventData,
    }),
  })

  const handleSelect = useCallback(() => {
    trackPromotion({ eventName: 'select_promotion', eventSource: SEARCH_EVENT_SOURCE.SEARCH_PAGE, eventData })
  }, [eventData])

  return { ref: observe, handleSelect }
}
